import { useQuery } from '@tanstack/react-query'
import { ExternalLink, Loader2, Route, Smartphone } from 'lucide-react'

import { Button } from '@/components/ui/button'
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card'
import { api } from '@/lib/api'
import { buildAppHref } from '@/lib/auth'

export function AdminOverviewPage() {
  const { data: projects, isLoading, error } = useQuery({
    queryKey: ['admin-projects-summary'],
    queryFn: () => api.adminListProjects(),
  })

  return (
    <Card className="bg-card/95 backdrop-blur-sm">
      <CardHeader>
        <CardTitle className="text-2xl">Projects</CardTitle>
      </CardHeader>
      <CardContent>
        {isLoading ? (
          <div className="py-12 text-center text-muted-foreground">
            <Loader2 className="mr-2 inline h-5 w-5 animate-spin" />
            Loading projects...
          </div>
        ) : null}

        {error ? (
          <div className="rounded-lg border-l-4 border-destructive bg-destructive/10 p-4 text-destructive">
            Failed to load projects: {(error as Error).message}
          </div>
        ) : null}

        {projects ? (
          <div className="flex flex-col divide-y rounded-md border">
            {projects.map(({ project, device_count, link_count }) => (
              <div key={project} className="flex items-center justify-between px-4 py-3">
                <div className="flex items-center gap-6">
                  <span className="font-semibold">{project}</span>
                  <span className="flex items-center gap-1.5 text-sm text-muted-foreground">
                    <Smartphone className="h-3.5 w-3.5" />
                    {device_count} {device_count === 1 ? 'device' : 'devices'}
                  </span>
                  <span className="flex items-center gap-1.5 text-sm text-muted-foreground">
                    <Route className="h-3.5 w-3.5" />
                    {link_count} {link_count === 1 ? 'link' : 'links'}
                  </span>
                </div>
                <Button asChild size="sm" variant="outline">
                  <a
                    href={buildAppHref('/', { mode: 'client', projectCode: project })}
                    className="no-underline"
                  >
                    <ExternalLink className="h-3.5 w-3.5" />
                    View client
                  </a>
                </Button>
              </div>
            ))}
          </div>
        ) : null}
      </CardContent>
    </Card>
  )
}
